import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API_BASE, withCredentials: true });

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const offset = -((document.querySelector("[data-testid=main-nav]")?.getBoundingClientRect().bottom ?? 76) + 16);
  if (window.__lenis) window.__lenis.scrollTo(el.getBoundingClientRect().top + window.scrollY + offset, { duration: 1.4 });
  else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY + offset, behavior: "smooth" });
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const CONTACT = {
  company: "SwayamScale AI Business Agency",
  tagline: "AI-Powered Digital Marketing & Business Automation Solutions",
  founder: "Abhishek Vyas",
  role: "Founder & AI Automation Specialist",
  phone: "7028371778",
  phoneHref: "tel:+917028371778",
  whatsapp: "https://wa.me/917028371778",
  email: "swayamscaleaibusinessagency@gmail.com",
  mailHref: "mailto:swayamscaleaibusinessagency@gmail.com",
  location: "Khese Park, Lohegaon, Pune, Maharashtra, India",
};
